import { EasyBorrowContainer } from '@/features/easy-borrow/EasyBorrowContainer'

export function EasyBorrowPage() {
  return <EasyBorrowContainer />
}
